export class ShareholderModel {
  id: number = null;
  sourceId: string = null;
  name: string = null;
  document: string = null;
  cetipAccount: string = null;
}
